import { createStore } from 'owa-satcheljs';
import type { ModuleContextMailboxInfoData } from './schema/ModuleContextMailboxInfoData';
import type { Module } from 'owa-workloads-module';
import type { MailboxInfo } from 'owa-client-types';

const defaultStore: ModuleContextMailboxInfoData = {
    moduleContextMailboxInfos: new Map<Module, MailboxInfo>(),
};

const defaultExport: () => ModuleContextMailboxInfoData = createStore<ModuleContextMailboxInfoData>(
    'ModuleContextMailboxInfoData',
    defaultStore
);
export default defaultExport;
